import {
  createRootRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
// import Header from '@/components/header';
import Credit from '@/components/credit';
import { Header } from '@/components/header2';
import { Toaster } from '@/components/ui/sonner';
import { isAuthenticated } from '@/lib/api';
import { useEffect, useState } from 'react';

export const Route = createRootRoute({
  component: () => {
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const hideHeaderPaths = [
      '/login',
      '/register',
      '/generate-qr',
      '/enter-code',
      '/reset-password',
      '/forgot-password',
      '/waiting',
      '/email-verified',
    ];
    const showHeader = !hideHeaderPaths.includes(pathname);

    useEffect(() => {
      setIsLoggedIn(isAuthenticated());
    }, [pathname]);

    return (
      <>
        {showHeader && (
          <Header
            isLoggedIn={isLoggedIn}
            links={[
              {
                label: 'TERMÉKEK',
                to: '/products',
                isScroll: true,
              },
              {
                label: 'KÜLDETÉSEK',
                to: '/challenges',
                isScroll: false,
              },
              {
                label: 'JÁTÉKSZABÁLY',
                to: '/rules',
                isScroll: false,
              },
            ]}
          />
        )}
        {showHeader && isLoggedIn && <Credit />}
        <Outlet />
        <Toaster richColors={true} />
        <TanStackRouterDevtools />
      </>
    );
  },
});
